import React from 'react';

export const DoubleArrows = ({ width = 12, height = 12, fill = 'black', className = '' }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        className={className}
    >
        <g clipPath="url(#clip0_1391_102)">
            <path
                d="M11.0605 4.9395L6.12298 0L5.41598 0.709L10.3535 5.6465C10.4472 5.74026 10.4999 5.86742 10.4999 6C10.4999 6.13258 10.4472 6.25974 10.3535 6.3535L5.40948 11.3L6.11648 12.007L11.0605 7.063C11.3417 6.78171 11.4997 6.40025 11.4997 6.0025C11.4997 5.60475 11.3417 5.22329 11.0605 4.942V4.9395Z"
                fill={fill}
            />
            <path
                d="M6.7675 5.64649L1.131 0.00949097L0.423499 0.716491L5.707 5.99999L0.417999 11.289L1.125 11.9965L6.7675 6.35349C6.86124 6.25973 6.91389 6.13257 6.91389 5.99999C6.91389 5.86741 6.86124 5.74026 6.7675 5.64649Z"
                fill={fill}
            />
        </g>
        <defs>
            <clipPath id="clip0_1391_102">
                <rect width="12" height="12" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
